import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-727e3da0")

_pushScopeId("data-v-727e3da0")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c" }
const _hoisted_2 = { class: "table table-dark table-striped" }
const _hoisted_3 = { scope: "col" }
const _hoisted_4 = { scope: "col" }
const _hoisted_5 = { scope: "col" }
const _hoisted_6 = { scope: "col" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = {
  scope: "col",
  class: "text-center"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-center"
}
const _hoisted_10 = { scope: "row" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_13 = {
  key: 1,
  class: "fas fa-times"
}
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "far fa-edit fa-lg" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt fa-lg" }, null, -1)
const _hoisted_17 = { class: "buttons-flex-list flex flex--width flex--h flex--halign-c flex--valign-c flex--gap-10" }
const _hoisted_18 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
const _hoisted_19 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inertia_link = _resolveComponent("inertia-link")
  const _component_PaginationNew = _resolveComponent("PaginationNew")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_GenericModal = _resolveComponent("GenericModal")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_school_dashboard')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("table", _hoisted_2, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_3, _toDisplayString(_ctx.$trans("company.id")), 1),
              _createVNode("th", _hoisted_4, _toDisplayString(_ctx.$trans("company.name")), 1),
              _createVNode("th", _hoisted_5, _toDisplayString(_ctx.$trans("event.organizer")), 1),
              _createVNode("th", _hoisted_6, _toDisplayString(_ctx.$trans("event.starting_at")), 1),
              _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$trans("event.ending_at")), 1),
              _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$trans("company.active")), 1),
              _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$trans("acp.options")), 1)
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events.data, (event) => {
              return (_openBlock(), _createBlock("tr", {
                key: event.id
              }, [
                _createVNode("th", _hoisted_10, _toDisplayString(event.id), 1),
                _createVNode("td", null, _toDisplayString(event.name), 1),
                _createVNode("td", null, _toDisplayString(event.organizer_name), 1),
                _createVNode("td", null, _toDisplayString(event.starting_at), 1),
                _createVNode("td", null, _toDisplayString(event.ending_at), 1),
                _createVNode("td", _hoisted_11, [
                  (event.active)
                    ? (_openBlock(), _createBlock("i", _hoisted_12))
                    : (_openBlock(), _createBlock("i", _hoisted_13))
                ]),
                _createVNode("td", _hoisted_14, [
                  (_ctx.policies.EVENT_CREATE)
                    ? (_openBlock(), _createBlock(_component_inertia_link, {
                        key: 0,
                        href: _ctx.route('school.events.edit', { event: event.id }),
                        class: "text-light"
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true),
                  (_ctx.policies.EVENT_DELETE)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "text-light",
                        onClick: ($event: any) => (_ctx.openDeleteEventModal(event.id))
                      }, [
                        _hoisted_16
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.events.data.length > 0)
          ? (_openBlock(), _createBlock(_component_PaginationNew, {
              key: 0,
              "pagination-data": _ctx.events,
              class: "pagination-new",
              onPaginate: _ctx.loadPage
            }, null, 8, ["pagination-data", "onPaginate"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_GenericButton, {
          title: _ctx.$trans('acp.event_create'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickRoute('school.events.create')))
        }, null, 8, ["title"]),
        _createVNode(_component_GenericButton, {
          title: _ctx.$trans('auth.account_delete'),
          danger: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDeleteAccountModal()))
        }, null, 8, ["title"])
      ]),
      (_ctx.deleteEventModalOpen)
        ? (_openBlock(), _createBlock(_component_GenericModal, {
            key: 0,
            onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeDeleteEventModal()))
          }, {
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$trans("acp.title_modal_delete_event")), 1)
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$trans("acp.body_modal_delete_event")), 1)
            ]),
            buttons: _withId(() => [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.close'),
                disabled: _ctx.loading,
                circular: true,
                "click-stop": false
              }, null, 8, ["title", "disabled"]),
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.delete'),
                disabled: _ctx.loading,
                circular: true,
                danger: true,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.deleteAction()), ["stop"]))
              }, null, 8, ["title", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.deleteAccountModalOpen)
        ? (_openBlock(), _createBlock(_component_GenericModal, {
            key: 1,
            onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeDeleteAccountModal()))
          }, {
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$trans("auth.title_modal_delete_account")), 1)
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$trans("auth.body_modal_delete_account")), 1)
            ]),
            buttons: _withId(() => [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.close'),
                disabled: _ctx.loading,
                circular: true,
                "click-stop": false
              }, null, 8, ["title", "disabled"]),
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('auth.account_delete'),
                disabled: _ctx.loading,
                circular: true,
                danger: true,
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteAccountAction()), ["stop"]))
              }, null, 8, ["title", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
})